// Section13.jsx — E Commerce Mobile Application Development
import React from 'react';
import { useReveal } from '../../componets/useScrollFX';
const ecommerceBanner = '../assets/E Commerce Mobile Application Development.webp';

const Section13 = () => {
  const features = [
    "Product catalogs", "Advanced search functionality", "Secure payment gateways",
    "Inventory management", "Customer accounts", "Order tracking",
    "Wishlist functionality", "Loyalty programs", "Push notifications", "Personalized recommendations"
  ];

  const benefits = [
    "Increase customer retention",
    "Improve conversion rates",
    "Boost repeat purchases",
    "Enhance customer engagement",
    "Strengthen brand loyalty",
  ];

  const integrations = [
    "Inventory systems",
    "CRM platforms",
    "ERP solutions",
    "Payment providers",
    "Analytics tools",
    "Marketing platforms",
  ];

  const [headRef, headVisible] = useReveal();
  const [bodyRef, bodyVisible] = useReveal();
  const [panelsRef, panelsVisible] = useReveal();

  return (
    <section id="ecommerce" className="bg-white py-10 md:py-10 relative overflow-hidden">
      {/* Background Accent */}
      <div className="absolute inset-0 bg-[radial-gradient(at_top_right,#cd212212_0%,transparent_50%)]" />

      <div className="max-w-7xl mx-auto px-6 relative">
        <div
          ref={headRef}
          className={`text-center mb-12 transition-all duration-700 ${
            headVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <span className="text-[#cd2122] text-xs font-semibold uppercase tracking-widest">Ecommerce</span>
          <h2 className="text-[32px] md:text-[38px] font-extrabold text-[#1a1a1a] mt-3 mb-4 leading-tight">
            E Commerce Mobile Application Development
          </h2>
          <p className="text-[#535353] text-[16px] max-w-2xl mx-auto">
            Mobile commerce continues to shape customer purchasing behavior. Businesses need engaging, reliable, and conversion-focused shopping experiences to remain competitive.
          </p>
        </div>

        <div
          ref={bodyRef}
          className={`max-w-5xl mx-auto transition-all duration-700 delay-150 ${
            bodyVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          {/* Storefront visual + copy */}
          <div className="grid md:grid-cols-1 gap-8 items-center bg-white/70 backdrop-blur-xl border border-white/60 shadow-2xl rounded-3xl p-8 md:p-10 mb-8">
            <div className="relative rounded-2xl overflow-hidden shadow-lg">
              <img src={ecommerceBanner} alt="Ecommerce mobile application development" className="w-full h-[280px] object-cover" />
            </div>
            <p className="text-[16px] text-[#535353] text-center max-w-2xl mx-auto">
              Our ecommerce mobile application development services help brands create seamless mobile shopping journeys that drive sales and customer loyalty.
            </p>
          </div>

          {/* Benefits + Integrations panels */}
          <div ref={panelsRef} className="grid md:grid-cols-2 gap-6 mb-8">
            <div
              className={`bg-[#fafafa] border border-gray-100 rounded-3xl p-8 transition-all duration-700 ${
                panelsVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
              }`}
            >
              <h4 className="text-xl font-bold text-[#1a1a1a] mb-2">Mobile Commerce Benefits</h4>
              <p className="text-[#535353] text-[15px] mb-5">A dedicated ecommerce mobile application can:</p>
              <ul className="space-y-3">
                {benefits.map((item, i) => (
                  <li key={i} className="flex items-center gap-3 text-[16px] text-[#535353]">
                    <span className="w-6 h-6 flex-shrink-0 rounded-full bg-[#cd2122]/10 text-[#cd2122] flex items-center justify-center text-xs font-bold">✓</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div
              style={{ transitionDelay: '150ms' }}
              className={`bg-[#fafafa] border border-gray-100 rounded-3xl p-8 transition-all duration-700 ${
                panelsVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
              }`}
            >
              <h4 className="text-xl font-bold text-[#1a1a1a] mb-2">Integrated Business Operations</h4>
              <p className="text-[#535353] text-[15px] mb-5">We connect your mobile commerce platform with:</p>
              <ul className="space-y-3 mb-5">
                {integrations.map((item, i) => (
                  <li key={i} className="flex items-center gap-3 text-[16px] text-[#535353]">
                    <span className="w-6 h-6 flex-shrink-0 rounded-full bg-[#cd2122]/10 text-[#cd2122] flex items-center justify-center text-xs font-bold">✓</span>
                    {item}
                  </li>
                ))}
              </ul>
              <p className="text-[15px] text-[#535353] pt-4 border-t border-gray-200">
                This creates a unified ecosystem that improves operational efficiency and customer experiences.
              </p>
            </div>
          </div>

          {/* Feature ticker — continuous marquee of what we build */}
          <div className="rounded-3xl border border-[#cd2122]/15 bg-[#fafafa] py-6 overflow-hidden">
          <h4 className="text-xl font-bold text-[#1a1a1a] mb-5 text-center">
            Features We Build
          </h4>
            <div className="flex whitespace-nowrap animate-[marquee_28s_linear_infinite] hover:[animation-play-state:paused]">
              {[...features, ...features].map((feature, i) => (
                <span key={i} className="flex items-center gap-2 mx-4 text-[15px] font-medium text-[#535353]">
                  <span className="w-1.5 h-1.5 bg-[#cd2122] rounded-full" />
                  {feature}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>
  );
};

export default Section13;